/**
 * Finance service: billing cycles only via Cloud Functions.
 * Data from getBillingCyclesAndPaymentsForAdmin (billingCycles only); totals computed in useBillingCycles.
 */

import { getBillingCyclesAndPaymentsForAdmin } from "../../../lib/api";
import type { GetBillingCyclesAndPaymentsResponse } from "../../../types";

export async function fetchBillingCycles(): Promise<GetBillingCyclesAndPaymentsResponse> {
  return getBillingCyclesAndPaymentsForAdmin();
}
